// HourItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Util from '../../../lib/util.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'

class HourItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      description: this.props.hour.description
        ? Util.convertHtmlToText(this.props.hour.description)
        : '',
      bInputTime: false,
      time:
        props.hour && props.hour.timeTaken
          ? this._formatTimeForInput(props.hour.timeTaken)
          : '',
      saved: false
    }

    this._references = {
      confirmTimeDelete: React.createRef()
    }

    this._saveTime = null
  }

  static get propTypes () {
    return {
      hour: PropTypes.object,
      onSave: PropTypes.func,
      onDelete: PropTypes.func,
      onOpenForm: PropTypes.func,
      onCloseForm: PropTypes.func,
      active: PropTypes.bool,
      time: PropTypes.object,
      onUpdateFavorite: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      hour: {},
      onSave: null,
      onDelete: null,
      onOpenForm: null,
      onCloseForm: null,
      active: false,
      time: null,
      onUpdateFavorite: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    const description = nextProps.hour
      ? Util.convertHtmlToText(nextProps.hour.description)
      : ''
    const time =
      nextProps.hour && nextProps.hour.timeTaken
        ? this._formatTimeForInput(nextProps.hour.timeTaken)
        : ''
    this.setState({ description: description, time: time })
  }

  render () {
    const hour = this.props.hour
    const _className = classnames('hour-item', {
      active: this.props.active,
      saved: this.state.saved
    })
    const _infoClassName = classnames('info', {
      editable: this.state.bInputTime
    })
    const timeOptions = [
      {
        label: 'time.item.labelFifteenMinutes',
        title: 'time.item.titleAdd15Minutes',
        value: 15
      },
      {
        label: 'time.item.labelThirtyMinutes',
        title: 'time.item.titleAdd30Minutes',
        value: 30
      },
      {
        label: 'time.item.labelOneHour',
        title: 'time.item.titleAddOneHour',
        value: 60
      },
      {
        label: 'time.item.labelTwoHour',
        title: 'time.item.titleAddTwoHour',
        value: 120
      },
      {
        label: 'time.item.labelFourHours',
        title: 'time.item.titleAddFourHours',
        value: 240
      },
      {
        label: 'time.item.labelEightHours',
        title: 'time.item.titleAddEightHours',
        value: 480
      }
    ]

    return (
      <div className={_className}>
        <div className='houredit'>
          {timeOptions.map((timeOpt, idx) => (
            <div
              title={IntlUtil.convertMessage(timeOpt.title)}
              key={idx}
              onClick={this._onIncrementTime.bind(this, timeOpt.value)}
              className='houroption'
            >
              <IntlMessage ident={timeOpt.label} />
            </div>
          ))}
          <span className='actclose' onClick={this._onClickClose.bind(this)}>
            <i className='icon icon-wizard-close' />
          </span>
        </div>
        {this.state.saved && <div className='marker'>&nbsp;</div>}
        <div className='content' onClick={this._onClickItem.bind(this)}>
          <div className='actions'>
            <IconButton
              icon={
                hour.isFavorite ? 'mobile-itemstar-hover' : 'mobile-itemstar'
              }
              size='normal'
              type={hour.isFavorite ? 'secondary' : 'normal'}
              canHover={!hour.isFavorite}
              className='time time_fav'
              onClick={this._onChangeFavourite.bind(this)}
            />
            <IconButton
              icon='mobile-itemdelete'
              size='small'
              className='time time_delete'
              onClick={this._onDelete.bind(this)}
              canHover
            />
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='time.form.tipSave'
              canHover={false}
              className='timemobile-save'
              onClick={this._onSave.bind(this)}
            />
          </div>
          <div className='contleft'>
            <div className={_infoClassName}>
              <div className='view' onClick={this._onClickTimeInput.bind(this)}>
                <span className='hours'>
                  {this.state.time ? this.state.time : '0:00'}
                </span>
              </div>
              <div className='edit'>
                <Input
                  type='text'
                  name='time'
                  className='mobile-input'
                  value={this.state.time}
                  size={10}
                  maxLength={100}
                  onChange={this._onChangeTimeTaken.bind(this)}
                  onBlur={this._onBlurTimeTaken.bind(this)}
                />
              </div>
            </div>
          </div>
          <div className='contright'>
            {hour.activityId ? (
              <h2 className='project'>{hour.project && hour.project.title}</h2>
            ) : (
              <h2 className='project'>{hour.activity}</h2>
            )}
            <span className='contact'>
              {hour.project &&
                hour.project.contact &&
                hour.project.contact.company}
            </span>
            {hour.activityId && (
              <span className='hourinfo'>{hour.activity}</span>
            )}
            <span
              className='description'
              dangerouslySetInnerHTML={{ __html: hour.description }}
            />
            <div className='edit'>
              <Input
                type='text'
                name='description'
                value={this.state.description}
                label='time.timeOption.description'
                className='mobile-desc'
                size={10}
                maxLength={100}
                validations={['required']}
                onChange={this._onChangeInput.bind(this, 'description')}
              />
            </div>
          </div>
          <ConfirmDelete
            ref={this._references.confirmTimeDelete}
            title='time.list.msgDelete'
            onClickOk={this._onClickDeleteConfirm.bind(this)}
          />
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChangeTimeTaken (value) {
    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(value)) {
      this.forceUpdate()
    } else {
      let timeTaken = 0
      const timeArr = value.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }

      const newTimeTaken = this._updateTimeTaken(timeTaken)
      if (newTimeTaken !== timeTaken) {
        this.setState({
          time: this._formatTimeForInput(newTimeTaken),
          dataDate: new Date()
        })
      } else {
        this.setState({ time: value })
      }
    }
  }

  _onBlurTimeTaken () {
    if (this.props.time) {
      this.setState({
        time: this._formatTimeForInput(this.props.time.timeTaken)
      })
    }
  }

  _onIncrementTime (incrValue) {
    const newTimeTaken = this._updateTimeTaken(
      parseInt(this.props.hour.timeTaken) + incrValue
    )
    this.setState({ time: this._formatTimeForInput(newTimeTaken) })
  }

  _formatTimeForInput (timeTaken) {
    if (timeTaken === 0) {
      return '0:00'
    }

    return timeTaken ? Util.convertMinutesToHour(timeTaken) : ''
  }

  _updateTimeTaken (timeTaken) {
    timeTaken = timeTaken > 24 * 60 ? 24 * 60 : timeTaken
    const timeObj = this.props.hour
    timeObj.timeTaken = timeTaken

    if (this._saveTime) window.clearTimeout(this._saveTime)

    this._saveTime = window.setTimeout(() => {
      this.props.onSave(timeObj.id, { timeTaken: timeTaken || 0 }, _err => {})
    }, 500)

    return timeTaken
  }

  _onClickTimeInput (e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ bInputTime: true, dataDate: new Date() })
  }

  _onClickItem (e) {
    e.preventDefault()
    if (this.props.onOpenForm) {
      this.props.onOpenForm(this.props.hour.id)
    }
  }

  _onClickClose (e) {
    e.preventDefault()
    if (this.props.onCloseForm) {
      this.props.onCloseForm(this.props.hour.id)
    }

    this.setState({ bInputTime: false })
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onChangeFavourite (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    const timeObj = this.props.hour
    timeObj.isFavorite = !timeObj.isFavorite
    this.props.onUpdateFavorite(timeObj, timeObj.isFavorite)
  }

  _onDelete (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this._references.confirmTimeDelete.current) {
      this._references.confirmTimeDelete.current.show()
    }
  }

  _onSave (ev) {
    ev.preventDefault()
    this._onClickClose(ev)

    this.props.onSave(
      this.props.hour.id,
      { description: this.state.description },
      _err => {
        this.setState({ saved: true })
        window.setTimeout(() => {
          this.setState({ saved: false })
        }, 2000)
      }
    )
  }

  _onClickDeleteConfirm (ev) {
    ev.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.props.hour.id)
    }
  }
}

export default HourItem
